<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left" v-show="show">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>{{ title }}</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right" type="primary" @click="show = false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" style="width: 100%" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="运单号" prop="freightBillCode">
              <el-input v-model.trim="form.freightBillCode" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="出库单号" prop="outBillCode">
              <el-input v-model.trim="form.outBillCode" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发货仓库" prop="fromWarehouseCode">
              <el-select v-model.trim="form.fromWarehouseCode" placeholder="请选择" style="width: 100%" filterable
                value-key="warehouseUuid" @change="currentSel">
                <el-option v-for="item in fromWarehouse" :key="item.warehouseUuid" :label="item.warehouseName"
                  :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划出库日期" prop="planOutDate">
              <el-date-picker v-model="form.planOutDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="经销商" prop="dealerCode">
              <el-select v-model="form.dealerCode" placeholder="输入经销商名称,编码" style="width:150px"
                :remote-method="getkeypagelist" @change="changedealer" filterable remote :loading="productloading">
                <el-option v-for="item in keypagelist" :key="item.depart_code" :label="item.depart_name"
                  :value="item.depart_code">
                  <span style="float: left">{{ item.depart_code }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.depart_name }}</span>
                </el-option>
              </el-select> <el-popover placement="right" width="400" v-model="visible">
                <el-table :data="dealerArea">
                  <af-table-column prop="provinceName" label="省" show-overflow-tooltip
                    min-width="150"></af-table-column>
                  <af-table-column prop="cityName" label="市" show-overflow-tooltip></af-table-column>
                  <af-table-column prop="areaName" label="区" show-overflow-tooltip></af-table-column>
                  <af-table-column prop="address" label="操作" width="80">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button type="success" @click.native.prevent="selectarea(scope.row)">选择</el-button>
                      </el-button-group>
                    </template>
                  </af-table-column>
                </el-table>
                <el-button slot="reference">区域</el-button>
              </el-popover>
            </el-form-item>

          </el-col>
          <el-col :span="18" v-if="form.dealerCode.length">
            <el-form-item label="选择地区" prop="provinceId">
              <el-col :span="4">
                <el-select style="width: 90%" clearable v-model="form.provinceId" placeholder="请选择省份"
                  @change="getcity(form.provinceId)" :disabled="true">
                  <el-option v-for="item in province" :key="item.code" :label="item.province" :value="item.code" />
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-select style="width: 90%" clearable v-model="form.cityId" placeholder="请选择市"
                  @change="getdistrict(form.cityId)" :disabled="form.cityId ? true : false">
                  <el-option v-for="item in city" :key="item.code" :label="item.city" :value="item.code" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select clearable v-model="form.districtId" style="width: 100%" placeholder="请选择区"
                  :disabled="form.districtId ? true : false">
                  <el-option v-for="item in district" :key="item.code" :label="item.area" :value="item.code" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model.trim="form.address" type="textarea" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-form-item>

          </el-col>

        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="8">
            <el-card shadow="never">
              <el-form ref="productform" :model="productform" label-width="110px" style="width: 80%" :rules="rules">
                <el-form-item label="产品" prop="productCode">
                  <el-select v-model="productform.productCode" placeholder="请输入产品名称" style="width: 60%"
                    :remote-method="getproductlist" @change="getproductname($event)" filterable remote
                    :loading="productloading">
                    <el-option v-for="item in productlist" :key="item.product_code" :label="item.product_name"
                      :value="item.product_code">
                      <span style="float: left">{{ item.product_code }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{
                        item.product_name
                      }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="计划出库数量" prop="planQuantity">
                  <el-input v-model.number="productform.planQuantity" style="width: 60%"></el-input>
                </el-form-item>
                <el-form-item label="包装单位" prop="unitCode">
                  <el-cascader ref="unitcascader" v-model="productform.unitCode" :options="packge_tree"
                    :show-all-levels="false" @change="getunitname"
                    :props="{ emitPath: false, checkStrictly: true, value: 'package_unit_code', label: 'product_unit_cn', children: 'child' }"
                    placeholder="请先选择产品" style="width: 60%">
                    <template slot-scope="{ node, data }">
                      <span>{{ data.product_unit_cn }}</span>
                      <span> </span>
                    </template>
                  </el-cascader>

                </el-form-item>
              </el-form>
              <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="resetForm('productform')">重置</el-button>
                <el-button style="margin-top: 12px" type="primary" @click="productadd('productform')">生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align: center">
            <el-button size="medium" style="margin-top: 100px" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="14">
            <el-card shadow="never">
              <el-table :data="tablelist" stripe style="width: 100%">
                <af-table-column prop="productName" label="产品名称" show-overflow-tooltip
                  min-width="150"></af-table-column>
                <af-table-column prop="productCode" label="产品编码" show-overflow-tooltip></af-table-column>
                <af-table-column prop="unitName" label="包装单位" show-overflow-tooltip></af-table-column>
                <af-table-column prop="planQuantity" label="计划生产数量" min-width="100"></af-table-column>
                <af-table-column prop="address" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="danger" @click.native.prevent="deleteRow(scope.$index, tablelist)">删除</el-button>
                    </el-button-group>
                  </template>
                </af-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center">
          <el-button style="margin-top: 12px" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { insertoutbillorder, updateoutbillorder } from "@/api/physical";
import { productlist } from "@/api/base";
import { findByParentCode, keypagelist } from "@/api/orgin";
import { packgetlist } from "@/api/base";
import { findwarehouse } from "@/api/query";
import { merchantsChannelsAreaslist } from "@/api/out";
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      //基础数据
      title: '新增出库单',
      productloading: false,
      visible: false,
      show: false,
      keypagelist: null, // 掉接口返回部门树
      productlist: [], //产品列表下拉
      fromWarehouse: [],
      packge_tree: [],
      form: {
        planOutDate: null,
        freightBillCode: null,
        outBillCode: null,
        outBillTime: null,
        fromWarehouseCode: null,
        fromWarehouse: null,
        dealerCode: '',
        dealerName: '',
        provinceId: null,
        cityId: null,
        districtId: null,
        address: '',
      },
      package_unit_code: [],
      dealerArea: [],
      productform: {
        //步骤1 表单
        is_traceability: 0,
        productCode: "",
        productName: "",
        planQuantity: null,
        unitCode: "",
        unitName: '',
        produceTime: null,
      },
      province: [],
      city: [],
      district: [],
      // 步骤2表格数据
      tablelist: [],
      rules: {
        cityId: [{ required: true, message: "请选择", trigger: "blur" },],
        provinceId: [{ required: true, message: "请选择", trigger: "blur" },],
        districtId: [{ required: true, message: "请选择", trigger: "blur" },],
        freightBillCode: [
          { required: true, message: "请输入运单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        outBillCode: [
          { required: true, message: "请输入出库单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        outBillTime: [{ required: true, message: "请输入出库时间", trigger: "blur" }],
        fromWarehouseCode: [
          { required: true, message: "请选择仓库编码", trigger: "blur" },
        ],
        dealerCode: [{ required: true, message: "请选择经销商编码", trigger: "blur" }],
        productCode: [{ required: true, message: "请选择产品", trigger: "blur" }],
        planQuantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur" },
        ],
        unitCode: [
          { required: true, message: "请选择包装单位", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getfromWarehouse();
    this.getproductlist();
    this.getkeypagelist()

    findByParentCode().then((response) => {
      this.province = response.data;
    });
  },
  methods: {
    selectarea(row) {
      this.form.provinceId = null;
      this.form.cityId = null;
      this.form.districtId = null;
      this.city = []; this.district = [];
      this.visible = false;
      if (row.provinceCode.length) {

        this.form.provinceId = row.provinceCode;
        this.getcity(row.provinceCode);
      }

      if (row.cityCode.length) {
        this.getdistrict(row.cityCode);
        this.form.cityId = row.cityCode;
      }
      if (row.areaCode.length) {

        this.form.districtId = row.areaCode;
      }


    },
    // 获取市
    getcity(code) {
      if (code) {
        this.city = [];
        this.form.cityId = "";
        this.form.districtId = "";
        findByParentCode({ parentCode: code }).then((response) => {
          this.city = response.data;
        });
      }

    },
    // 获取区
    getdistrict(code) {
      if (code) {

        this.district = [];
        this.form.districtId = "";
        findByParentCode({ parentCode: code }).then((response) => {
          this.district = response.data;
        });
      }

    },
    // 获取经销商区域列表
    changedealer(val) {
      this.form.provinceId = null;
      this.form.cityId = null;
      this.form.districtId = null;
      this.form.address = '';
      this.keypagelist.find((data => {
        if (data.depart_code == val) {
          this.form.dealerName = data.depart_name;
        }
      }))
      merchantsChannelsAreaslist({
        "page": 1,
        "limit": 10,
        "code": val
      }).then(response => {
        this.dealerArea = response.data.list
      });
    },
    // //请求部门树结构
    getkeypagelist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          keypagelist({
            "keyword": value,
            "isFilterKeyWordsThenChildren": true,
            "pageIndex": 1,
            "pageSize": 10
          }).then(response => {
            this.keypagelist = response.data.items;
          });
        }, 200);
      } else {
        this.keypagelist = [];
      }
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var opt = {};
          opt = Object.assign({}, this.productform)
          this.tablelist.push(opt);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then((response) => {
            this.productlist = response.data.data;
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    // 获取包装单位名称
    getunitname(val) {
      let node = this.$refs['unitcascader'].getCheckedNodes()[0];
      this.productform.unitName = node.label;
    },
    getproductname(e) {
      let obj = {};
      obj = this.productlist.find((item) => {
        return item.product_code === e; //筛选出匹配数据
      });
      console.log(obj, '产品详情啊')
      this.productform.productName = obj.product_name;
      this.productform.is_traceability = obj.is_traceability;
      packgetlist({ product_code: e, web_show: 1 }).then((response) => {
        this.packge_tree = response.data;
      })
    },
    currentSel(e) {
      this.form.fromWarehouseCode = e.warehouseName;
      this.form.fromWarehouse = e.warehouseName.split("|")[1];
    },
    // 根据仓库编码获取名称
    getfromWarehouse(value) {
      findwarehouse({ warehouseCode: value }).then((response) => {
        this.fromWarehouse = response.data;
        for (let i = 0; i < this.fromWarehouse.length; i++) {
          this.fromWarehouse[i].warehouseName =
            this.fromWarehouse[i].warehouseCode +
            "|" +
            this.fromWarehouse[i].warehouseName;
        }
      });
    },
    getTreeData(data) {
      // 去除树空子集
      for (var i = 0; i < data.length; i++) {
        if (data[i].listSubWareHouses.length < 1) {
          data[i].listSubWareHouses = undefined;
        } else {
          this.getTreeData(data[i].listSubWareHouses);
        }
      }
      return data;
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        //基础表单验证
        if (valid) {
          let obj = this.form;
          obj.fromWarehouseCode = this.form.fromWarehouseCode.split("|")[0];
          obj.orderProductsEntityList = this.tablelist;
          if (this.title == '新增出库单') {
            insertoutbillorder(obj).then((response) => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "添加成功!",
                });
                this.search();
                this.tablelist = [];
                this.resetForm(formName);
                this.show = false;

              } else {
                this.$message({
                  type: "warning",
                  message: "添加失败!请检查字段",
                });
              }
            });
          } else {
            updateoutbillorder(obj).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "提交成功!"
                });
                this.search();
                this.tablelist = [];
                this.resetForm(formName);
                this.show = false;
              } else {
                this.$message({
                  type: "warning",
                  message: "提交失败!请检查字段"
                });
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped></style>
